module.exports = __webpack_public_path__ + "static/3-b37fb25161aff5e9f8e9cd3c9e0784c2.jpg";